/* eslint-disable @typescript-eslint/no-unused-vars */
import { Component, OnInit } from '@angular/core';

import { of, timer } from 'rxjs';
import { map, mergeMap } from 'rxjs/operators';
import {
  DomainService,
  IDomain,
  ImagemService,
  TokenService
} from 'viggo-sistemas-core-web';

import { DomainOrgService } from '@app/shared/services';
import { ValidadorSettingsApplication } from '@app/shared/utils/validar_settings_application';

@Component({
  selector: 'dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
  providers: [ImagemService]
})
export class DashboardComponent implements OnInit {
  // TODO: ALTERANDO AQUI ALTERA O CARD DE PRIMEIRO CONTATO
  infoFirstContact = {
    title: 'Me fala do seu negócio?',
    subtitle: `Vamos adicionar algumas informações sobre o seu negócio? clica
    na setinha!`,
    description: `As informações que serão adicionadas aqui servirão para nós e seus
            clientes sabermos um pouco mais sobre sua empresa e facilitar a
            identificação nas nossas bases`,
    url: ['dados-empresa/editar']
  };

  links = {
    config: '../dados-empresa/settings',
    edit: '../dados-empresa/editar'
  };

  public showCardPerfil = false;
  public dadosEmpresa: IDomain = null;
  public loading = true;

  public constructor(
    protected domainService: DomainService,
    protected domainOrgService: DomainOrgService,
    protected imagemService: ImagemService,
    protected tokenService: TokenService
  ) {}

  /**
   * Baixa as informações de domain
   */
  protected verificarDadosEmpresa(): void {
    this.domainService
      .getEntity(this.tokenService.getDomain().id, 'application')
      .pipe(
        mergeMap(dadosEmpresa => {
          // caso tenha uma foto ela baixa
          if (dadosEmpresa.logo_id)
            return this.imagemService
              .donwloadImagem({
                imagemId: dadosEmpresa.logo_id,
                mapToBase64: true
              })
              .pipe(
                map(
                  (logo): IDomain => ({
                    ...dadosEmpresa,
                    logo_file: logo
                  })
                )
              );
          return of(dadosEmpresa);
        })
      )
      .subscribe(dadosempresa => {
        timer(1000).subscribe(() => {
          this.loading = false;
        });
        this.validateRules(dadosempresa);
        if (
          !dadosempresa.contacts ||
          dadosempresa.contacts.length === 0 ||
          !dadosempresa.addresses ||
          dadosempresa.addresses.length === 0
        )
          this.dadosEmpresa = {} as IDomain;
        else {
          this.dadosEmpresa = dadosempresa;
          this.showCardPerfil = true;
        }
      });
  }

  validateRules(dadosempresa) {
    dadosempresa.application.settings = new ValidadorSettingsApplication(
      dadosempresa.application.settings
    ).getApplicationSettingsBody(dadosempresa.application.settings) as any;
    if (
      dadosempresa.application.settings.regras !== undefined &&
      dadosempresa.application.settings.regras.usa_integracao
    )
      localStorage.setItem(
        'INTEGRACAO',
        dadosempresa.application.settings.regras.usa_integracao
      );
    else localStorage.setItem('INTEGRACAO', 'false');
  }
  /**
   * @lifeCycle
   */
  public ngOnInit() {
    this.verificarDadosEmpresa();
  }
}
